import { Button, ButtonProps, ButtonSize, ButtonVariant } from '.';
import React from 'react';
import { Metrics } from '@att-bit/duc.utils.types';
import { ComponentInterfaceBaseClass } from '@att-bit/duc.utils-ts.types';

export interface ButtonRuntimeProps {
  onClick?: () => void;
}

export class ButtonInterface
  extends ComponentInterfaceBaseClass
  implements ButtonProps
{
  children: React.ReactNode;
  disabled?: boolean;
  fullWidth?: boolean;
  mobileFullWidth?: boolean;
  spinnerLabel?: string;
  href?: string;
  isNavigational?: boolean;
  metrics?: Metrics;
  onDark?: boolean;
  size?: ButtonSize;
  spinner?: boolean;
  svgNodeStr?: string;
  svgUrl?: string;
  variant?: ButtonVariant;
  margin?: string[];
  isModal?: boolean;
  modalChildren?: any;
  modalSize?: any;
  modalVideoContent?: any;
  isNewTab?: boolean;
  accessibilityText?: string;
  triggerEvent?: string;
  triggerData?: any;
  eventReporting?: boolean;
  additionalAnalyticsData?: any;

  static initWithSanity(key, feed) {
    const t = new ButtonInterface();
    const config = feed?.configs || {};
    const isSvg = feed?.svgIcon?.includes('svg') ? true : false;
    let isSvgStr;
    t.children = feed?.text;
    t.href = feed?.href;
    t.disabled = config?.disabled;
    t.fullWidth = config?.fullWidth;
    t.mobileFullWidth = config?.mobileFullWidth;
    t.onDark = config?.onDark;
    t.size =
      ((Object as any).values(ButtonSize).includes(config.size) &&
        config.size) ||
      undefined;
    t.spinner = config?.spinner;
    t.spinnerLabel = feed?.spinnerLabel;
    t.variant =
      ((Object as any).values(ButtonVariant).includes(config.variant) &&
        config.variant) ||
      undefined;
    if (isSvg) {
      isSvgStr = feed.svgIcon?.includes('<svg') ? true : false;
    }
    t.svgNodeStr = isSvgStr ? feed?.svgIcon : undefined;
    t.svgUrl = !isSvgStr ? feed?.svgIcon : undefined;
    t.isNavigational = feed?.isNavigational;
    t.margin = feed?.margin
      ? feed.margin
      : config?.margin
      ? config.margin.split(' ')
      : [];
    t.isModal = config?.function === 'modal' ? true : false;
    t.isNewTab = config?.function === 'newtab' ? true : false;
    t.accessibilityText = feed?.accessibilityText;
    const modalTitle = feed?.modalTitle;
    const modalContent = feed?.modalContent;
    t.modalChildren = { modalTitle, modalContent };
    t.modalSize = config?.modalSize;
    t.modalVideoContent = feed?.videoBackgroundData;
    t.eventReporting = feed?.eventReporting;
    t.additionalAnalyticsData = feed?.additionalAnalyticsData;
    const trigEvt = config?.function;
    t.triggerEvent =
      trigEvt && trigEvt !== 'modal' && trigEvt !== 'newtab'
        ? trigEvt
        : undefined;
    t.triggerData = config[`${t.triggerEvent}Data`] || null;
    return t;
  }

  // private clicked = (event: MouseEvent) => {
  //     if (this.onClick) {
  //         this.onClick(event);
  //     }
  // }

  toProps(buttonRuntimeProps?): ButtonProps {
    return {
      children: this.children,
      href: this.href,
      disabled: this.disabled,
      fullWidth: this.fullWidth,
      mobileFullWidth: this.mobileFullWidth,
      onDark: this.onDark,
      size: this.size,
      spinner: this.spinner,
      variant: this.variant,
      svgNodeStr: this.svgNodeStr,
      svgUrl: this.svgUrl,
      isNavigational: this.isNavigational,
      margin: this.margin,
      isModal: this.isModal,
      isNewTab: this.isNewTab,
      accessibilityText: this.accessibilityText,
      modalChildren: this.modalChildren,
      modalSize: this.modalSize,
      modalVideoContent: this.modalVideoContent,
      //onClick: this.clicked,
      spinnerLabel: this.spinnerLabel,
      triggerEvent: this.triggerEvent,
      triggerData: this.triggerData,
      eventReporting: this.eventReporting,
      additionalAnalyticsData: this.additionalAnalyticsData,
      ...buttonRuntimeProps,
    };
  }

  toJsx(
    buttonRuntimeProps?: React.ButtonHTMLAttributes<HTMLButtonElement>
  ): JSX.Element {
    return React.createElement(Button, {
      ...this.toProps(buttonRuntimeProps),
    });
  }
}
